import ym from 'react-yandex-metrika';

import { HelikaEvent, helika } from './helika';

type AnalyticsEvent = HelikaEvent;

class AnalyticsService {
  public sendEvent(event: AnalyticsEvent): void {
    this.sendToHelika(event);
    if (Number(import.meta.env.VITE_YANDEX_METRIKA_ID)) {
      this.sendToYandexMetrika(event);
    }
  }

  private async sendToHelika(event: AnalyticsEvent): Promise<void> {
    await helika.sendEvent(event);
  }

  private sendToYandexMetrika(e: AnalyticsEvent): void {
    try {
      const { event } = e;
      ym('reachGoal', event.event_sub_type, event);
    } catch (error) {
      console.error('Failed to send event to Yandex.Metrika:', error);
    }
  }
}

export const analytics = new AnalyticsService();
